<ng-template #contentTemplate>
	<ng-content></ng-content>
</ng-template>
@if (linkMode() === 'router') {
<ng-container>
	@if (processedRouterLink(); as processedRouterLink) {
	<a [routerLink]="processedRouterLink" class="ui-link" [class.no-underline]="linkStyle() === 'noUnderline'">
		<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
	</a>
	} @else {
	<div class="ui-link" [class.no-underline]="linkStyle() === 'noUnderline'">
		<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
	</div>
	}
</ng-container>
} @else if (linkMode() === 'external') {
<ng-container>
	@if (externalUrl(); as externalUrl) {
	<a [target]="'_blank'" [href]="externalUrl" class="ui-link" [class.no-underline]="linkStyle() === 'noUnderline'">
		<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template> </a
	>}
</ng-container>
} @else if (linkMode() === 'anchorRoute') {
<ng-container>
	<a [href]="processedAnchorRoute()" class="ui-link" [class.no-underline]="linkStyle() === 'noUnderline'">
		<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
	</a>
</ng-container>
}
